import React from "react";
import PdfViewer from "../comman/PdfViewer";
import { marketingDocs } from "../consfig";

const TipkitParksDeck = () => {
  const pdfUrl = marketingDocs.tipkitParksDeck;

  return <PdfViewer pdfFile={pdfUrl} />;
};

export default TipkitParksDeck;
